export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'È un prodotto fisico?',
    answer: 'No. SMART HOME PRO™ è un prodotto 100% digitale e riceverai l’accesso dopo l’acquisto.',
  },
  {
    question: 'È adatto a chi parte completamente da zero?',
    answer:
      'Sì. Il sistema è stato strutturato proprio per accompagnarti progressivamente dalle fondamenta fino alla progettazione, configurazione, automazione e integrazione di sistemi Smart Home, senza richiedere conoscenze avanzate iniziali.',
  },
  {
    question: 'È solo teoria sulla domotica?',
    answer:
      'No. La teoria viene utilizzata per comprendere ciò che stai facendo, ma il sistema è costruito intorno ad applicazioni pratiche, procedure passo-passo, esempi, checklist, schemi, configurazioni e progetti progressivi.',
  },
  {
    question: 'Devo già conoscere Zigbee, Matter, Thread o Home Assistant?',
    answer:
      'No. Questi argomenti vengono introdotti progressivamente nel momento in cui diventano necessari, così puoi capire prima le fondamenta e affrontare successivamente integrazioni più avanzate.',
  },
  {
    question: 'Imparerò a creare automazioni?',
    answer:
      'Sì. Imparerai la logica di trigger, condizioni e azioni e la applicherai a scenari di illuminazione, climatizzazione, sicurezza, presenza, comfort, routine ed efficienza energetica.',
  },
  {
    question: 'Posso utilizzare il sistema per progetti reali?',
    answer:
      'Sì. Il percorso include progettazione, selezione dei dispositivi, configurazione, automazioni, integrazioni, test, troubleshooting e documentazione, oltre a casi completi che mostrano come organizzare un progetto dall’inizio alla fine.',
  },
  {
    question: 'Devo acquistare dispositivi costosi per seguire il sistema?',
    answer:
      'No. Puoi studiare tutti i moduli senza acquistare nulla. Quando vuoi passare alla pratica, il sistema spiega quali dispositivi scegliere, con quali criteri e come costruire un primo ecosistema economico ed espandibile.',
  },
  {
    question: 'Quanto tempo serve per completare i sei moduli?',
    answer:
      'Dipende dal tuo ritmo. Il percorso è progressivo e l’accesso è illimitato: puoi seguirlo modulo per modulo dedicandogli poche ore alla settimana e riprendere le procedure e le checklist ogni volta che lavori a un progetto.',
  },
  {
    question: 'SMART HOME PRO™ sostituisce un elettricista o un tecnico abilitato?',
    answer:
      'No. Il sistema insegna progettazione, configurazione, automazione e gestione della Smart Home. Gli interventi elettrici o regolamentati che richiedono specifiche qualifiche devono essere eseguiti da professionisti abilitati secondo le normative applicabili.',
  },
  {
    question: 'Come riceverò l’accesso?',
    answer: 'Subito dopo il pagamento. Riceverai tutto via email entro pochi minuti.',
  },
]
